import { PropTypes } from 'prop-types';
import React, { Fragment } from 'react';

import ListBy from './ListBy';
import ListSize from './ListSize';
import SortOrder from './SortOrder';
import NumberOfItems from './NumberOfItems';

const ListConfiguration = ({
  onDataChange, count, order, size, type
}) => (
    <Fragment>
      <div>
        Configure this list
      </div>
      <hr />
      <div>
        <ListBy onDataChange={onDataChange} type={type} />
        <hr />
        <NumberOfItems onDataChange={onDataChange} count={count} />
        <hr />
        {/* <ListSize onDataChange={onDataChange} size={size} /> */}
        {/* <hr /> */}
        <SortOrder onDataChange={onDataChange} order={order} />
        <hr />
      </div>
    </Fragment>
  );


ListConfiguration.propTypes = {
  onDataChange: PropTypes.func,
  count: PropTypes.string,
  order: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string
};

ListConfiguration.defaultProps = {
  onDataChange: () => { },
  count: '',
  order: '',
  size: '',
  type: ''
};

export default ListConfiguration;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/configuration-elements/ListConfiguration.js